import React from 'react';

import AsyncSelect from 'react-select/async';
import Select from 'react-select';

import { connect } from 'react-redux';
import { Schemas } from '../../middleware/api'
import { getSort } from '../../util'

import get from 'lodash/get';
import { 
  loadRecommenderRules,
  createRecommenderRule,
  deleteRecommenderRule,
  getHeaders
} from '../../actions'
import { connectPagination } from '../../decorators'
import { Table } from '../Generic'
import { Column } from '@rapiddot/react-virtual-list'
import classnames from 'classnames'

import './Boosting.css'

const SingleValue = ({
  cx,
  getStyles,
  selectProps,
  data,
  isDisabled,
  className,
  ...props
}) => {
  return (
    <div>{selectProps.getOptionLabel(data)}</div>
    // <div>{selectProps.getOptionValue(data)}</div>
  );
};


class RuleList extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      addNewRuleFormActive: false,
      player_group_id: 'all',
      rule_factor: 1.0,
      rule_type: {value: 'multiplier'},
      rule_type_options:[
          {value: 'multiplier', label: 'multiplier'},
          {value: 'fixed', label: 'fixed'}
        ]
    }
    this._handleChange = this._handleChange.bind(this)
  }

  _deleteRule(rowData) {
    const { deleteRecommenderRule } = this.props
    deleteRecommenderRule(rowData.id)
  }

  _renderActionButton(row, type) {

    const isActive = true;

    return (
      <div
        key={`${type}-task`}
        className={classnames('btn btn-extra-sm', {'selected btn-danger': isActive})}
        onClick={this._deleteRule.bind(this, row)}
      >
        <span>{type}</span>
        {isActive && <i className="fa fa-cog fa-spin a-fw"></i>}
      </div>
    )
  }

  _handleSubmit = (e) => {
    const { createRecommenderRule } = this.props
    let params = {}
    if (this.state.player_group_id && this.state.player_group_id !== 'all') {
      params['player_group_id'] = this.state.player_group_id
    }
    params['rule_factor'] = this.state.rule_factor
    params['rule_item_type'] = this.state.rule_item_id.type
    params['rule_item_id'] = this.state.rule_item_id.value
    params['rule_type'] = this.state.rule_type.value

    this.setState({
      player_group_id: 'all',
      rule_factor: 1.0,
      rule_type: {value: 'multiplier'},
    })
    createRecommenderRule(params)
    this.setState({addNewRuleFormActive: false})
    e.preventDefault()
  }

  _handleChange = (e) => {
    const target = e.target
    const value = target.type === 'checkbox' ? target.checked : target.value
    const name = target.name
    this.setState({
      [name]: value
    })
  }

  _handleSelectChange = (name, newValue) => {
    this.setState({ [name]: newValue });
  };

  _renderForm() {
    return (
      <form className="form form--boxed" csrf_token="true" left='50%' onSubmit={this._handleSubmit} method='post'>
        <div className="form-field">
          <label className="form-field__label">Player Group:</label>
          <input 
            className="form-field__input" 
            type="text" 
            onChange={this._handleChange}
            name="player_group_id"
            value={this.state.player_group_id}>
          </input>
        </div>
        <div className="form-field">
          <label className="form-field__label">Hierarchy Id:</label>
            <AsyncSelect
              id="async-select-rec-rule-id"
              className="form-field__input"
              components={{ SingleValue }}
              cacheOptions
              defaultOptions
              onChange={this._handleSelectChange.bind(this, 'rule_item_id')}
              loadOptions={this.searchEvents.bind(this)}
            />
        </div>
        <div className="form-field">
          <label className="form-field__label">Boosting Type:</label>
          <Select
            className="form-field__input" 
            defaultValue={this.state.rule_type_options[0]}
            options={this.state.rule_type_options}
            onChange={this._handleSelectChange.bind(this, 'rule_type')}
          />
        </div>
        <div className="form-field">
          <label className="form-field__label">Boosting Factor:</label>
          <input 
            className="form-field__input" 
            type="text" 
            onChange={this._handleChange}
            name="rule_factor"
            value={this.state.rule_factor}>
          </input>
        </div>

        <button className="button btn btn-sm btn-primary" type="submit">Submit rule</button>
        <button className="button btn btn-sm" onClick={this._newRuleForm.bind(this, false)}>Cancel</button>
      </form>
    )
  }
  
  searchEvents = async (inputValue) => {
    if (inputValue) {
      if (inputValue.length >=3) {
        const response = await fetch('/api/entities/?search_string='+inputValue, { 
          method: 'get',
          headers: getHeaders(this.props.state),
        })
        const results = await response.json()
        let json = []
        results.forEach( res => {
          json.push({
            value:res['id'], 
            label: <div><div>{res['type']}</div><div><strong>{res['id']}</strong></div><div>{res['desc']}</div></div>,
            type:res['type'],
            isFixed: true})
      })

      return json
      }
    }
  };

  _newRuleForm(active) {
    this.setState({addNewRuleFormActive: active})
  }

  render() {
    const { pagination, totalItems } = this.props

    return (
      <div className="players-table-wrapper">

          <div className="table-info-header hbox">
            <div className="hbox--flex">
              { !totalItems && get(pagination, 'isFetching')  && <div className="table-info-header">Loading rules...</div> }
              { this.props.title && <div className="table-title">{this.props.title}</div>}        
              { this.props.totalItems > 0 && <div className="table-info-header">showing {this.props.totalItems} rules...</div> }
            </div>
            <div className="table-info-header__toolbar">
              <div 
                className="table-info-header__toolbar-item button btn btn-sm btn-primary"
                onClick={this._newRuleForm.bind(this, true)}
              >
                  Add Rule
                </div>
            </div>
          </div>

        <Table {...this.props} rowHeight={40} className="generic-table">

          <Column
            label='Players Group'
            dataKey='player_group_id'
            cellRenderer={({rowData}) => get(rowData, 'player_group_id') || 'all'}
            className='small-table-column'
          />

          <Column
            label='Boosting Item Type'
            dataKey='rule_item_type'
            className='generic-table-column'
          />

          <Column
            label='Boosting Item Id'
            dataKey='rule_item_id'
            className='generic-table-column'
          />

          <Column
            label=' Boosting Factor'
            dataKey='rule_factor'
            className='generic-table-column'
          />

          <Column
            label=' Boosting Type'
            dataKey='rule_type'
            className='generic-table-column'
          />

          <Column
            label='Delete'
            dataKey='delete'
            cellRenderer={({rowData}) => ([
              this._renderActionButton(rowData, 'delete'),
          ])}
            className='small-table-column'
          />

        </Table>
        {get(pagination, 'isFetching') ? <div className="loader"></div> : <div />}
        {this.state.addNewRuleFormActive ? this._renderForm():<div />}        

      </div>
    )
  }
}

const withPagination = connectPagination({
    entitykey: 'recommenderRules',
    loadItems: loadRecommenderRules,
    itemSchema: Schemas.RECOMMENDER_RULE,
    getQueryParams: ({state, ownProps}) => {
      return {
        ...get(state, 'routing.locationBeforeTransitions.query')
      }
    },
    title: 'Recommender Rules Pagination',
  })(RuleList)
  
export default connect(
(state, ownProps) => ({
    location: ownProps.location,
    ...getSort(get(ownProps, 'location.query.ordering', '-id')),
    recommenderRules: get(state, 'entities.recommenderRules')
}),
{ createRecommenderRule, deleteRecommenderRule, loadRecommenderRules }, 
)(withPagination)


// WEBPACK FOOTER //
// ./src/components/Boosting/Boosting.js